import { ProtectedRoute } from '@components/protectedRoute';
import { DashboardsProvider } from '@contexts/dashboards';
import { appRoutes } from '@utils/consts';

export const dashboardsRoutes = [
  {
    path: appRoutes.dashboards,
    lazy: async () => {
      const { Dashboards } = await import('@pages/dashboards');
      return {
        Component: () => (
          <ProtectedRoute>
            <DashboardsProvider>
              <Dashboards />
            </DashboardsProvider>
          </ProtectedRoute>
        ),
      };
    },
  },
];
